module.exports = __webpack_public_path__ + "img/default_cover.d333abe2.png";